import classNames from "classnames";
import { TypeAheadInput } from "common/components/filterBar/TypeAhead";
import { Component } from "react";
import { FixedSizeList as List } from "react-window";
import { faPlus, faMinus } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { FilterItemRow } from "./FilterItemRowStyle";

export class FilterTokenMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            operator: this.props.token.operator === "=" ? "included" : "excluded",
            selectedItems: [...this.props.selectedItems],
            data: [...this.props.data],
            applyingChanges: false
        };
    }
    
    itemClick = (id) => () => {
        const findIndex = this.state.selectedItems.indexOf(id);
        if (findIndex === -1) {
            this.setState((prevState, props) => ({ selectedItems: [...prevState.selectedItems, id] }));
        } else {
            this.setState((prevState, props) => ({ selectedItems: prevState.selectedItems.filter((i) => i !== id) }));
        }
    };
    
    setOperator = (operator) => () => {
        this.setState({ operator });
    };
    
    ApplyFilters = () => {
        this.setState(
            { applyingChanges: true },
            this.props.onApply({
                operator: this.state.operator === "included" ? "" : "-",
                selectedItems: this.state.selectedItems
            })
        );
    };
    
    cancelChanges = () => {
        this.setState({
            data: [...this.props.data],
            operator: this.props.token.operator === "=" ? "included" : "excluded",
            selectedItems: [...this.props.selectedItems]
        });
        this.props.onCancel();
    };
    
    onBeforeClose = () => {
        if (!this.state.applyingChanges) {
            this.cancelChanges();
        }
        this.props.onClose();
    };
    
    searchResults = (results) => {
        if (results.value.length) {
            this.setState({ data: results.raw });
        } else {
            this.setState({ data: [...this.props.data] });
        }
    };
    
    renderSelectedFilters() {
        // eslint-disable-next-line react/function-component-definition
        const listResults = (filterList, selected) => ({
            key, index, isScrolling, isVisible, style
        }) => {
            const item = filterList[index];
            const itemSelected = this.state.selectedItems.includes(item.id);
            return (
                <FilterItemRow style={style} key={`${key}_${item.id}`} onClick={this.itemClick(item.id)}>
                    <div className={classNames(`operator-icon ${this.state.operator}`, { selected: itemSelected })}>
                        <FontAwesomeIcon className="excluded" icon={faMinus} />
                        <FontAwesomeIcon className="included" icon={faPlus} />
                    </div>
                    <div className="row-label">
                        <div className="item-value">{item.alias}</div>
                    </div>
                </FilterItemRow>
            );
        };
        
        if (this.state.data.length) {
            return (
                <div className="list">
                    <List
                        height={190}
                        itemCount={this.state.data.length}
                        itemSize={26}
                        width={248}
                    >
                        {listResults(this.state.data, this.state.selectedItems)}
                    </List>
                </div>
            );
        }
        return null;
    }
    
    render() {
        return (
            <div className="token-menu">
                <div className="operator-toggle">
                    <header>{this.props.token.pivot_alias}</header>
                    <div className={`btns ${this.state.operator}`}>
                        <div onClick={this.setOperator("included")} className="btn left">+Include</div>
                        <div onClick={this.setOperator("excluded")} className="btn right">-Exclude</div>
                    </div>
                </div>
                <div className="menu-filter">
                    <TypeAheadInput srcData={this.state.data} onTypeAhead={this.searchResults} onePerCategory={false} />
                </div>
                {this.renderSelectedFilters()}
                <div className="btn-row">
                    <div className="btn btn-secondary" onClick={this.ApplyFilters}>Apply filters</div>
                </div>
                <div className="btn-row">
                    <div className="btn" onClick={this.cancelChanges}>Cancel</div>
                </div>
            </div>
        );
    }
}
